<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The River Below</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h2 class="chapter-number">PROLOGUE</h2>
<p class="flush-left-opener"><span class="big">T</span>hey found the car on Thursday.</p>
<p class="indented">Timothy Slates and Ramon Reyes, another landscape technician, had been out in the river in their little boat with the outboard doing cleanup work. Timothy was one of the young men Wally had mentored when he was alive. Back then, when Timothy was only seventeen, he’d seemed almost too handsome with his large dark eyes and black hair he pulled into a ponytail. Claire Barrett had watched his unchanging smile as Wally called him ‘Buddy,’ and patted him on the back. She had noted Timothy’s halting speech. Yet in spite of or maybe because of his slow, careful manner, he had been able to land a full-time job with the river conservancy after he received his GED. Now, after Wally’s death, he was acting restoration technician.</p>
<p class="indented">Timothy was the one who found it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter000a.vue?79159890